import PortfolioManualTradeDetail from './PortfolioManualTradeDetail';

export default PortfolioManualTradeDetail;
